import { ListStoreDefault, ListRequestHandler, ListFilterHandler, ListSuccessHandler } from 'js/helpers/reducers.js';

import {
  FETCH_COMPETITORS_FEED,
  FETCHED_COMPETITORS_FEED,
  SET_COMPETITORS_FEED_FILTER,
  FETCH_SUBSCRIBED_FEED,
  FETCHED_SUBSCRIBED_FEED,
  SET_SUBSCRIBED_FEED_FILTER,
  FETCH_SAVED_FEED,
  FETCHED_SAVED_FEED,
  SET_SAVED_FEED_FILTER,
 } from 'components/Pages/Library/actions.js';

const defaultState = {
  competitorContentList: ListStoreDefault({
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    content_type: '',
    searchQuery: '',
    searchBy: '',
    pageSize: 40,
    pageNum: 1,
    sortBy: 'publish_date',
    sortOrder: 'desc',
  }),
  savedContentList: ListStoreDefault({
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    content_type: '',
    searchQuery: '',
    searchBy: '',
    pageSize: 40,
    pageNum: 1,
  }),
  subscribedContentList: ListStoreDefault({
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    content_type: '',
    searchQuery: '',
    searchBy: '',
    pageSize: 40,
    pageNum: 1,
    sortBy: 'publish_date',
    sortOrder: 'desc',
  }),
};

const LibraryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case FETCH_COMPETITORS_FEED:
      return ListRequestHandler(state, action, 'competitorContentList');
    case FETCH_SUBSCRIBED_FEED:
      return ListRequestHandler(state, action, 'subscribedContentList');
    case FETCH_SAVED_FEED:
      return ListRequestHandler(state, action, 'savedContentList');
    case FETCHED_COMPETITORS_FEED:
      return ListSuccessHandler(state, action, 'competitorContentList');
    case FETCHED_SUBSCRIBED_FEED:
      return ListSuccessHandler(state, action, 'subscribedContentList');
    case FETCHED_SAVED_FEED:
      return ListSuccessHandler(state, action, 'savedContentList');
    case SET_COMPETITORS_FEED_FILTER:
      return ListFilterHandler(state, action, 'competitorContentList');
    case SET_SUBSCRIBED_FEED_FILTER:
      return ListFilterHandler(state, action, 'subscribedContentList');
    case SET_SAVED_FEED_FILTER:
      return ListFilterHandler(state, action, 'savedContentList');
    default:
      return Object.assign({}, state);
  }
};

export default LibraryReducer;
